import { useQuery } from "@tanstack/react-query";

import { get } from "../helpers/HTTP";
import getQueryKeys from "./getQueryKeys";

import type { DetailedWorkspace } from "../types";

async function getWorkspaceRequest(
  workspaceId: string,
): Promise<DetailedWorkspace> {
  return (await get(`workspaces/${workspaceId}`)).workspace;
}

export default function useWorkspaceDetails(workspaceId: string) {
  const {
    data: workspace,
    isLoading: isLoadingWorkspace,
    error: workspaceError,
    refetch: refetchWorkspace,
  } = useQuery({
    queryKey: getQueryKeys(workspaceId).workspaceKeys.base,
    queryFn: () => getWorkspaceRequest(workspaceId),
  });

  return {
    workspace,
    workspaceError,
    isLoadingWorkspace,
    refetchWorkspace,
  };
}
